import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "app-wrapper"
}
const _hoisted_2 = { class: "app-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_notifications = _resolveComponent("notifications")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_MobileBar = _resolveComponent("MobileBar")!
  const _component_AppMenu = _resolveComponent("AppMenu")!
  const _component_SiteHeader = _resolveComponent("SiteHeader")!
  const _component_LoadingPage = _resolveComponent("LoadingPage")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_notifications, { position: "top right" }),
    (_ctx.isFullScreen)
      ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.$bp.isMobile)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_MobileBar),
                _createVNode(_component_AppMenu)
              ], 64))
            : (_openBlock(), _createBlock(_component_SiteHeader, { key: 1 })),
          _createElementVNode("div", _hoisted_2, [
            (_ctx.loading)
              ? (_openBlock(), _createBlock(_component_LoadingPage, { key: 0 }))
              : (_openBlock(), _createBlock(_Transition, {
                  key: 1,
                  name: "fade",
                  mode: "out-in"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_view)
                  ]),
                  _: 1
                }))
          ]),
          _createVNode(_component_Footer)
        ]))
  ], 64))
}